import { render, staticRenderFns } from "./SidePane.vue?vue&type=template&id=b271cb38&scoped=true&"
import script from "./SidePane.vue?vue&type=script&lang=js&"
export * from "./SidePane.vue?vue&type=script&lang=js&"
import style0 from "./SidePane.vue?vue&type=style&index=0&id=b271cb38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b271cb38",
  null
  
)

export default component.exports